export default __webpack_public_path__ + "static/media/Smart-Biology-LIFE-U4-Cover-Image.e64c2702.jpg";